module.exports = __webpack_public_path__ + "img/7-min.7111b8f9.jpg";